module.exports = __webpack_public_path__ + "img/dots.d4bd0bfd.svg";